document.addEventListener('DOMContentLoaded', () => {
  const RECEIPT_PRICE_SYNC_TYPE = 'VYRX_PC_PLAN_PRICE_SYNC';
  const RECEIPT_READY_TYPE = 'VYRX_PC_PLAN_RECEIPT_READY';
  const RECEIPT_PRINT_STARTED_TYPE = 'VYRX_PC_PLAN_PRINT_STARTED';
  const RECEIPT_PRINT_COMPLETE_TYPE = 'VYRX_PC_PLAN_PRINT_COMPLETE';
  const RECEIPT_RESIZE_TYPE = 'VYRX_PC_PLAN_RECEIPT_RESIZE';

  document.querySelectorAll('[data-vyrx-pc-plan-page]').forEach((section) => {
    const form = section.querySelector('[data-vyrx-pc-plan-form]');
    const cartForm = section.querySelector('[data-vyrx-pc-plan-cart-form]');
    const propertiesTarget = section.querySelector('[data-vyrx-pc-plan-properties]');
    const summary = section.querySelector('[data-vyrx-pc-plan-summary]');
    const error = section.querySelector('[data-vyrx-pc-plan-error]');
    const backButton = section.querySelector('[data-vyrx-pc-plan-back]');
    const progress = section.querySelector('[data-vyrx-pc-plan-progress]');
    const stepCurrent = section.querySelector('[data-vyrx-pc-plan-step-current]');
    const stepTotal = section.querySelector('[data-vyrx-pc-plan-step-total]');
    const topbar = section.querySelector('.vyrx-pc-plan-page__topbar');
    const budgetCurrencyCopy = section.querySelector('[data-vyrx-budget-currency-copy]');
    const budgetCurrencyLabel = section.querySelector('[data-vyrx-budget-currency-label]');
    const budgetCurrencyInput = section.querySelector('[data-vyrx-budget-currency-input]');
    const sequence = section.querySelector('[data-vyrx-sequence]');
    const receiptEmbed = section.querySelector('[data-vyrx-pc-plan-receipt-embed]');
    const receiptFrame = receiptEmbed?.querySelector('.vyrx-pc-plan-page__receipt-frame') || null;
    const receiptFrameShell = receiptEmbed?.querySelector('.vyrx-pc-plan-page__receipt-frame-shell') || null;
    const checkoutCta = section.querySelector('[data-vyrx-pc-plan-checkout-cta]');
    const checkoutCtaButton = checkoutCta?.querySelector('[data-vyrx-pc-plan-checkout-button]') || null;
    const preCheckoutReveal = section.querySelector('[data-vyrx-pc-plan-precheckout]');
    const preCheckoutRevealItems = Array.from(section.querySelectorAll('[data-vyrx-pc-plan-precheckout-item]'));
    const preCheckoutRevealHeading = preCheckoutRevealItems[0] || null;
    const preCheckoutRevealDelivery = preCheckoutRevealItems[preCheckoutRevealItems.length - 1] || null;
    const preCheckoutRevealBenefits = preCheckoutRevealItems.slice(1, -1);
    const panels = Array.from(section.querySelectorAll('[data-vyrx-pc-plan-step]'));
    const reviewPanel = section.querySelector('[data-vyrx-pc-plan-step="review"]');
    const shell = section.querySelector('.vyrx-pc-plan-page__shell');

    if (!form || !cartForm || !propertiesTarget || !error || !backButton || !shell || !sequence) return;

    const contextualPrice = section.dataset.price || '';
    const budgetCurrencyCode = getCurrencyCode(contextualPrice, section.dataset.budgetCurrencyCode || 'CAD');
    const budgetCurrencySymbol = getCurrencySymbol(contextualPrice) || '$';
    const storageKey = `vyrx-pc-plan-intake:${section.dataset.sectionId || 'default'}`;
    const mobileLayoutQuery = window.matchMedia('(max-width: 749px)');
    const MOBILE_RECEIPT_BOTTOM_RESERVE = 16;
    const MOBILE_VISIBLE_RECEIPT_BOTTOM = 758;
    const MOBILE_RECEIPT_CTA_GAP = 16;
    const MOBILE_RECEIPT_MIN_SCALE = 0.6;
    let autoAdvanceTimer = null;
    let sequenceStarted = false;
    let sequenceTimers = [];
    let sequenceRunId = 0;
    let receiptMessageCleanup = null;
    let checkoutCtaTimer = null;
    let lastReceiptHeight = 0;
    let isPreCheckoutRevealActive = false;
    let completionExperienceStarted = false;
    let checkoutNavigationStarted = false;
    let hasFiredStarted = false;
    let hasFiredCompleted = false;
    let hasFiredValueReveal = false;
    let hasFiredReceiptViewed = false;

    function trackPcPlanEvent(name, params) {
      try {
        if (typeof window.gtag !== 'function') return;
        window.gtag('event', name, params || {});
      } catch {}
    }

    function markQuestionnaireStarted() {
      if (hasFiredStarted) return;
      hasFiredStarted = true;
      trackPcPlanEvent('pc_plan_started');
    }

    const optionLabels = {
      plan_type: {
        new_pc: 'Build me a new PC plan',
        upgrade_pc: 'Upgrade my current PC',
        prebuilt: 'Help me choose a prebuilt',
        not_sure: 'I’m not sure yet',
      },
      budget_range: {
        under_750: `Under $750 ${budgetCurrencyCode}`,
        '750_1000': `$750–$1,000 ${budgetCurrencyCode}`,
        '1000_1500': `$1,000–$1,500 ${budgetCurrencyCode}`,
        '1500_2000': `$1,500–$2,000 ${budgetCurrencyCode}`,
        '2000_2500': `$2,000–$2,500 ${budgetCurrencyCode}`,
        '2500_3500': `$2,500–$3,500 ${budgetCurrencyCode}`,
        '3500_5000': `$3,500–$5,000 ${budgetCurrencyCode}`,
        '5000_plus': `$5,000+ ${budgetCurrencyCode}`,
        flexible: 'Flexible / not sure',
        other: 'Other amount',
      },
      primary_use: {
        gaming: 'Gaming',
        gaming_streaming: 'Gaming + streaming',
        work_school: 'Work / school',
        content_creation: 'Content creation',
        mixed_use: 'Mixed use',
        not_sure: 'Not sure yet',
      },
      gaming_style: {
        competitive: 'Competitive / esports',
        aaa: 'AAA games',
        sim_racing: 'Sim / racing',
        minecraft_sandbox: 'Minecraft / sandbox',
        strategy_sim: 'Strategy / simulation',
        mixed: 'I play a mix',
      },
      workload_focus: {
        productivity: 'Productivity',
        school: 'School / everyday work',
        editing: 'Editing / creative apps',
        rendering: '3D / rendering',
        mixed: 'I do a mix',
        not_sure: 'Not sure',
      },
      performance_target: {
        highest_fps: 'Highest FPS',
        better_graphics: 'Better graphics',
        balanced: 'Balance of both',
        not_sure: 'Recommend it for me',
      },
      target_resolution: {
        '1080p': '1080p',
        '1440p': '1440p',
        '4k': '4K',
        not_sure: 'Not sure',
      },
      aesthetics_style: {
        clean_minimal: 'Clean / minimal',
        rgb_gaming: 'RGB gaming',
        all_black: 'All black',
        white_build: 'White build',
        showcase: 'Showcase build',
        dont_care: 'Performance first',
      },
      appearance_importance: {
        performance_first: 'Performance first',
        balanced: 'Balanced',
        appearance_matters: 'Appearance matters a lot',
      },
      wifi_need: {
        yes: 'Yes',
        no: 'No',
        not_sure: 'Not sure',
      },
      storage_priority: {
        '1tb': '1TB is enough',
        '2tb': 'I want 2TB+',
        lots: 'Lots of storage',
        recommend: 'Recommend it for me',
      },
      upgrade_goals: {
        fps: 'More FPS / gaming performance',
        storage: 'More storage',
        performance: 'Faster overall performance',
        cooling: 'Cooling / temperatures',
        appearance: 'Appearance',
        productivity: 'Streaming / productivity',
        not_sure: 'Not sure',
        other: 'Other',
      },
    };

    const defaultState = {
      currentStep: 'service',
      submission_id: '',
      submission_status: '',
      submitted_at: '',
      plan_type: '',
      budget_range: '',
      budget_other_amount: '',
      primary_use: '',
      gaming_style: '',
      workload_focus: '',
      performance_target: '',
      target_resolution: '',
      aesthetics_style: '',
      appearance_importance: '',
      wifi_need: '',
      storage_priority: '',
      current_pc_details: '',
      primary_upgrade_goal: '',
      upgrade_goal_other: '',
      current_pc_link: '',
      prebuilt_options: '',
      additional_notes: '',
      plan_acknowledgement: false,
    };

    let state = loadFreshState();

    syncBudgetCurrencyUi();
    applyStateToForm();
    render();

    backButton.addEventListener('click', handleBack);
    if (summary) {
      summary.addEventListener('click', handleSummaryEdit);
    }
    form.addEventListener('click', handleStepActionClick);
    form.addEventListener('click', handleChoiceInteraction);
    form.addEventListener('input', handleFormChange);
    form.addEventListener('change', handleFormChange);
    form.addEventListener('submit', (event) => event.preventDefault());
    checkoutCtaButton?.addEventListener('click', (event) => {
      event.preventDefault();
      trackPcPlanEvent('pc_plan_checkout_clicked', {
        currency: budgetCurrencyCode,
        price_displayed: contextualPrice,
      });
      void submitToCheckout(checkoutCtaButton);
    });
    window.addEventListener('resize', updateMobileReceiptScale);
    mobileLayoutQuery.addEventListener('change', updateMobileReceiptScale);
    window.visualViewport?.addEventListener('resize', updateMobileReceiptScale);

    function loadFreshState() {
      try {
        window.localStorage.removeItem(storageKey);
      } catch {}

      return { ...defaultState };
    }

    function getCurrencyCode(priceText, fallbackCode) {
      const matches = String(priceText).trim().match(/[A-Z]{3}\b/g);
      return matches?.length ? matches[matches.length - 1] : fallbackCode;
    }

    function getCurrencySymbol(priceText) {
      const trimmed = String(priceText).trim();
      const match = trimmed.match(/[^0-9\s.,-]+/);
      return match ? match[0] : '';
    }

    function syncBudgetCurrencyUi() {
      if (budgetCurrencyCopy) {
        budgetCurrencyCopy.textContent = `All ranges are in ${budgetCurrencyCode}.`;
      }

      if (budgetCurrencyLabel) {
        budgetCurrencyLabel.textContent = `Custom budget (${budgetCurrencyCode})`;
      }

      if (budgetCurrencyInput) {
        budgetCurrencyInput.placeholder = `${budgetCurrencySymbol}2,200 ${budgetCurrencyCode}`;
      }
    }

    function saveState() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch {}
    }

    function clearState() {
      try {
        window.localStorage.removeItem(storageKey);
      } catch {}
    }

    function clearSequenceTimers() {
      sequenceTimers.forEach((timerId) => window.clearTimeout(timerId));
      sequenceTimers = [];
    }

    function clearCheckoutCtaTimer() {
      if (checkoutCtaTimer) {
        window.clearTimeout(checkoutCtaTimer);
        checkoutCtaTimer = null;
      }
    }

    function hideCheckoutCta() {
      clearCheckoutCtaTimer();
      if (!checkoutCta) return;
      checkoutCta.classList.remove('is-visible');
      checkoutCta.setAttribute('aria-hidden', 'true');
      if (checkoutCtaButton) {
        checkoutCtaButton.disabled = false;
        checkoutCtaButton.removeAttribute('aria-busy');
      }
    }

    function applyReceiptFrameHeight(nextHeight) {
      if (!receiptFrame || !receiptEmbed || !reviewPanel) return;
      const numericHeight = Number(nextHeight);
      if (!Number.isFinite(numericHeight) || numericHeight <= 0) return;
      lastReceiptHeight = Math.ceil(numericHeight);
      section.style.setProperty('--vyrx-pc-plan-receipt-height', `${lastReceiptHeight}px`);
      updateMobileReceiptScale();
    }

    function updateMobileReceiptScale() {
      if (!receiptEmbed) return;
      if (!mobileLayoutQuery.matches || !lastReceiptHeight || !reviewPanel?.classList.contains('is-active')) {
        section.style.setProperty('--vyrx-pc-plan-receipt-scale', '1');
        section.style.setProperty('--vyrx-pc-plan-receipt-scaled-height', `${lastReceiptHeight}px`);
        section.style.removeProperty('--vyrx-pc-plan-mobile-cta-top');
        return;
      }
      const embedTop = receiptEmbed.getBoundingClientRect().top;
      const available = window.innerHeight - embedTop - MOBILE_RECEIPT_BOTTOM_RESERVE;
      const scale = Math.min(1, Math.max(MOBILE_RECEIPT_MIN_SCALE, available / MOBILE_VISIBLE_RECEIPT_BOTTOM));
      const scaledHeight = Math.round(MOBILE_VISIBLE_RECEIPT_BOTTOM * scale);
      section.style.setProperty('--vyrx-pc-plan-receipt-scale', String(scale));
      section.style.setProperty('--vyrx-pc-plan-receipt-scaled-height', `${scaledHeight}px`);
      updateMobileCheckoutCtaPosition(scale);
    }

    function updateMobileCheckoutCtaPosition(scaleOverride) {
      if (!mobileLayoutQuery.matches || !reviewPanel?.classList.contains('is-active') || !checkoutCta || !receiptFrameShell) {
        section.style.removeProperty('--vyrx-pc-plan-mobile-cta-top');
        return;
      }

      const scale =
        typeof scaleOverride === 'number' && Number.isFinite(scaleOverride)
          ? scaleOverride
          : Number.parseFloat(getComputedStyle(section).getPropertyValue('--vyrx-pc-plan-receipt-scale')) || 1;
      const reviewTop = reviewPanel.getBoundingClientRect().top;
      const receiptTop = receiptFrameShell.getBoundingClientRect().top;
      const ctaTop = Math.round(
        receiptTop -
          reviewTop +
          MOBILE_VISIBLE_RECEIPT_BOTTOM * scale +
          MOBILE_RECEIPT_CTA_GAP
      );

      section.style.setProperty('--vyrx-pc-plan-mobile-cta-top', `${ctaTop}px`);
    }

    function revealCheckoutCta() {
      clearCheckoutCtaTimer();
      if (!checkoutCta) return;
      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450;
      checkoutCtaTimer = window.setTimeout(() => {
        checkoutCtaTimer = null;
        updateMobileReceiptScale();
        checkoutCta.classList.add('is-visible');
        checkoutCta.setAttribute('aria-hidden', 'false');
      }, delay);
    }

    function wait(delay) {
      return new Promise((resolve) => {
        const timerId = window.setTimeout(() => {
          sequenceTimers = sequenceTimers.filter((activeId) => activeId !== timerId);
          resolve();
        }, delay);
        sequenceTimers.push(timerId);
      });
    }

    function nextPaint() {
      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(resolve);
        });
      });
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function getCheckoutDestination() {
      return section.dataset.checkoutUrl || `${window.Shopify.routes.root}checkout`;
    }

    function navigateToCheckout(destination = getCheckoutDestination()) {
      if (checkoutNavigationStarted) return;
      checkoutNavigationStarted = true;
      window.location.assign(destination);
    }

    function revealNode(node) {
      if (!node) return;
      node.hidden = false;
      window.requestAnimationFrame(() => {
        node.classList.add('is-visible');
      });
    }

    function hideNode(node) {
      if (!node) return;
      node.classList.remove('is-visible');
      node.hidden = true;
    }

    function getStage(stageName) {
      return sequence.querySelector(`[data-vyrx-sequence-stage="${CSS.escape(stageName)}"]`);
    }

    function getStageNode(stageName, nodeName) {
      return getStage(stageName)?.querySelector(`[data-vyrx-sequence-node="${CSS.escape(nodeName)}"]`) || null;
    }

    function resetStageNodes(stageName) {
      const stage = getStage(stageName);
      if (!stage) return;
      stage.querySelectorAll('[data-vyrx-sequence-node]').forEach((node) => {
        if (node.getAttribute('data-vyrx-sequence-node') !== 'built-kicker') {
          hideNode(node);
        } else {
          node.classList.remove('is-visible');
          node.hidden = false;
        }
      });
    }

    function setSequenceStage(stageName) {
      sequence.dataset.vyrxSequenceState = stageName;
      sequence.querySelectorAll('[data-vyrx-sequence-stage]').forEach((stage) => {
        const isActive = stage.getAttribute('data-vyrx-sequence-stage') === stageName;
        stage.hidden = !isActive;
        stage.classList.toggle('vyrx-pc-plan-page__sequence-stage--active', isActive);
      });
    }

    async function activateSequenceStage(runId, stageName) {
      const nextStage = getStage(stageName);
      const currentStage = sequence.querySelector('.vyrx-pc-plan-page__sequence-stage--active');

      if (!nextStage) return;

      if (currentStage && currentStage !== nextStage) {
        currentStage.classList.remove('vyrx-pc-plan-page__sequence-stage--active');
        await wait(220);
        if (sequenceRunId !== runId) return;
        currentStage.hidden = true;
      }

      sequence.dataset.vyrxSequenceState = stageName;
      nextStage.hidden = false;
      await new Promise((resolve) => window.requestAnimationFrame(resolve));
      if (sequenceRunId !== runId) return;
      nextStage.classList.add('vyrx-pc-plan-page__sequence-stage--active');
    }

    function resetSequence() {
      clearSequenceTimers();
      sequenceRunId += 1;
      sequenceStarted = false;
      completionExperienceStarted = false;
      resetStageNodes('intro-built');
      setSequenceStage('intro-built');
    }

    function resetPreCheckoutReveal() {
      isPreCheckoutRevealActive = false;
      document.body.classList.remove('vyrx-pc-plan-intake-template--precheckout-reveal');

      if (!preCheckoutReveal) return;

      preCheckoutReveal.hidden = true;
      preCheckoutReveal.setAttribute('aria-hidden', 'true');
      preCheckoutReveal.classList.remove('is-active', 'is-exiting');
      preCheckoutRevealItems.forEach((item) => {
        item.classList.remove('is-visible');
      });
    }

    async function runPreCheckoutReveal() {
      if (!preCheckoutReveal || !preCheckoutRevealItems.length || !reviewPanel) return;

      const reducedMotion = prefersReducedMotion();
      const overlayFadeDuration = reducedMotion ? 160 : 420;
      const headingLeadDelay = reducedMotion ? 80 : 1000;
      const itemStagger = reducedMotion ? 0 : 1000;
      const holdDuration = reducedMotion ? 320 : 1700;
      const exitFadeDuration = reducedMotion ? 180 : 420;

      resetPreCheckoutReveal();
      isPreCheckoutRevealActive = true;
      document.body.classList.add('vyrx-pc-plan-intake-template--precheckout-reveal');
      preCheckoutReveal.hidden = false;
      preCheckoutReveal.setAttribute('aria-hidden', 'false');

      await nextPaint();
      if (checkoutNavigationStarted) return;
      preCheckoutReveal.classList.add('is-active');
      if (!hasFiredValueReveal) {
        hasFiredValueReveal = true;
        trackPcPlanEvent('pc_plan_value_reveal_viewed');
      }

      await wait(overlayFadeDuration);
      if (checkoutNavigationStarted) return;

      if (reducedMotion) {
        preCheckoutRevealItems.forEach((item) => {
          item.classList.add('is-visible');
        });
      } else {
        if (preCheckoutRevealHeading) {
          preCheckoutRevealHeading.classList.add('is-visible');
          await wait(headingLeadDelay);
          if (checkoutNavigationStarted) return;
        }

        for (const item of preCheckoutRevealBenefits) {
          item.classList.add('is-visible');
          await wait(itemStagger);
          if (checkoutNavigationStarted) return;
        }

        if (preCheckoutRevealDelivery) {
          preCheckoutRevealDelivery.classList.add('is-visible');
          await wait(itemStagger);
          if (checkoutNavigationStarted) return;
        }
      }

      await wait(holdDuration);
      if (checkoutNavigationStarted) return;

      preCheckoutReveal.classList.remove('is-active');
      preCheckoutReveal.classList.add('is-exiting');
      await wait(exitFadeDuration);
      if (checkoutNavigationStarted) return;
      resetPreCheckoutReveal();
    }

    function resetReceiptEmbed() {
      if (receiptMessageCleanup) {
        receiptMessageCleanup();
        receiptMessageCleanup = null;
      }
      hideCheckoutCta();
      if (!receiptEmbed || !receiptFrame) return;
      receiptEmbed.hidden = true;
      receiptFrame.hidden = true;
      receiptFrame.removeAttribute('src');
    }

    function startReceiptEmbed() {
      if (!receiptEmbed || !receiptFrame) return;
      hideCheckoutCta();
      receiptEmbed.hidden = false;
      receiptFrame.hidden = false;
      const nextSrc = receiptFrame.dataset.src;
      const storefrontPrice = receiptFrame.dataset.price || contextualPrice;
      const storefrontRegularPrice = receiptFrame.dataset.regularPrice || storefrontPrice;
      const storefrontSavingsPrice = receiptFrame.dataset.savingsPrice || '';
      const storefrontHasDiscount = receiptFrame.dataset.hasDiscount === 'true';
      if (!nextSrc) return;

      const iframeUrl = new URL(nextSrc, window.location.href);
      const iframeOrigin = iframeUrl.origin;
      iframeUrl.searchParams.set('parentOrigin', window.location.origin);

      const syncPrice = () => {
        receiptFrame.contentWindow?.postMessage(
          {
            type: RECEIPT_PRICE_SYNC_TYPE,
            price: storefrontPrice,
            regularPrice: storefrontRegularPrice,
            savingsPrice: storefrontSavingsPrice,
            hasDiscount: storefrontHasDiscount,
          },
          iframeOrigin
        );
      };

      if (receiptMessageCleanup) {
        receiptMessageCleanup();
      }

      const handleReceiptMessage = (event) => {
        if (event.origin !== iframeOrigin) return;
        if (event.source !== receiptFrame.contentWindow) return;
        if (!event.data || typeof event.data !== 'object') return;
        if (event.data.type === RECEIPT_READY_TYPE) {
          hideCheckoutCta();
          syncPrice();
          return;
        }
        if (event.data.type === RECEIPT_RESIZE_TYPE) {
          applyReceiptFrameHeight(event.data.height);
          return;
        }
        if (event.data.type === RECEIPT_PRINT_STARTED_TYPE) {
          hideCheckoutCta();
          return;
        }
        if (event.data.type === RECEIPT_PRINT_COMPLETE_TYPE) {
          if (!hasFiredReceiptViewed) {
            hasFiredReceiptViewed = true;
            trackPcPlanEvent('pc_plan_receipt_viewed');
          }
          revealCheckoutCta();
        }
      };

      const handleReceiptLoad = () => {
        hideCheckoutCta();
        syncPrice();
      };

      window.addEventListener('message', handleReceiptMessage);
      receiptFrame.addEventListener('load', handleReceiptLoad);
      receiptMessageCleanup = () => {
        window.removeEventListener('message', handleReceiptMessage);
        receiptFrame.removeEventListener('load', handleReceiptLoad);
      };

      const targetSrc = iframeUrl.toString();
      if (receiptFrame.getAttribute('src') !== targetSrc) {
        receiptFrame.setAttribute('src', targetSrc);
      } else {
        syncPrice();
      }
    }

    async function playStageSequence(runId, stageName, options) {
      if (sequenceRunId !== runId) return;
      await activateSequenceStage(runId, stageName);
      if (sequenceRunId !== runId) return;
      const kicker = options.kicker ? getStageNode(stageName, options.kicker) : null;

      if (kicker) {
        revealNode(kicker);
      }

      await wait(options.kickerDelay || 520);
      if (sequenceRunId !== runId) return;
      await wait(options.afterDelay || 240);
    }

    async function startSequence() {
      if (completionExperienceStarted) return;
      completionExperienceStarted = true;
      if (!hasFiredCompleted) {
        hasFiredCompleted = true;
        trackPcPlanEvent('pc_plan_completed');
      }
      hideError();
      const runId = sequenceRunId;

      await nextPaint();
      if (sequenceRunId !== runId) return;
      resetPreCheckoutReveal();
      hideCheckoutCta();
      resetReceiptEmbed();

      await runPreCheckoutReveal();
      if (sequenceRunId !== runId || checkoutNavigationStarted) return;

      startReceiptEmbed();
    }

    function getActiveSteps() {
      const steps = ['service', 'budget'];
      if (state.budget_range === 'other') steps.push('budget_other');
      steps.push('use_primary');

      if (['gaming', 'gaming_streaming', 'mixed_use'].includes(state.primary_use)) {
        steps.push('gaming_style', 'performance_target', 'target_resolution');
      } else {
        steps.push('workload_focus');
      }

      steps.push('aesthetics_style', 'appearance_importance', 'wifi_need', 'storage_priority');

      if (state.plan_type === 'upgrade_pc') {
        steps.push('upgrade_goal_primary');
        if (state.primary_upgrade_goal === 'other') steps.push('upgrade_goal_other');
        steps.push('current_pc_details', 'current_pc_link');
      }
      if (state.plan_type === 'prebuilt') steps.push('prebuilt_options');
      steps.push('additional_notes', 'review');
      return steps;
    }

    function getCurrentStepIndex() {
      return Math.max(getActiveSteps().indexOf(state.currentStep), 0);
    }

    function handleSummaryEdit(event) {
      const button = event.target.closest('[data-vyrx-edit-step]');
      if (!button) return;
      const step = button.getAttribute('data-vyrx-edit-step');
      if (!step) return;
      state.currentStep = step;
      saveState();
      render();
      focusCurrentStep();
    }

    function handleFormChange(event) {
      markQuestionnaireStarted();
      syncStateFromForm();
      normalizeState();
      if (event.target.name === 'plan_type') {
        const activeSteps = getActiveSteps();
        if (!activeSteps.includes(state.currentStep)) state.currentStep = activeSteps[0];
      }
      saveState();
      render();

      if (shouldAutoAdvanceOnSelection(event)) {
        queueAutoAdvance();
      }
    }

    function handleChoiceInteraction(event) {
      const choice = event.target.closest('.vyrx-pc-plan-page__choice, .vyrx-pc-plan-page__chip');
      if (!choice) return;
      markQuestionnaireStarted();
      window.requestAnimationFrame(() => {
        syncStateFromForm();
        saveState();
        render();
      });
    }

    function handleStepActionClick(event) {
      const actionButton = event.target.closest('[data-vyrx-pc-plan-next]');
      if (!actionButton) return;
      event.preventDefault();
      void handleNext();
    }

    function handleBack() {
      hideError();
      const steps = getActiveSteps();
      const currentIndex = getCurrentStepIndex();

      if (currentIndex === 0) {
        const referrer = document.referrer ? new URL(document.referrer, window.location.origin) : null;
        const sameOriginReferrer = referrer && referrer.origin === window.location.origin ? referrer.pathname + referrer.search + referrer.hash : '';
        window.location.assign(sameOriginReferrer || section.dataset.returnUrl || window.Shopify.routes.root);
        return;
      }

      const previousStep = steps[currentIndex - 1];
      clearStepValue(previousStep);
      normalizeState();
      state.currentStep = previousStep;
      saveState();
      applyStateToForm();
      render();
      focusCurrentStep();
    }

    function clearStepValue(step) {
      const resetsByStep = {
        service: () => {
          state.plan_type = '';
        },
        budget: () => {
          state.budget_range = '';
          state.budget_other_amount = '';
        },
        budget_other: () => {
          state.budget_other_amount = '';
        },
        use_primary: () => {
          state.primary_use = '';
          state.gaming_style = '';
          state.workload_focus = '';
          state.performance_target = '';
          state.target_resolution = '';
        },
        gaming_style: () => {
          state.gaming_style = '';
        },
        workload_focus: () => {
          state.workload_focus = '';
        },
        performance_target: () => {
          state.performance_target = '';
        },
        target_resolution: () => {
          state.target_resolution = '';
        },
        aesthetics_style: () => {
          state.aesthetics_style = '';
        },
        appearance_importance: () => {
          state.appearance_importance = '';
        },
        wifi_need: () => {
          state.wifi_need = '';
        },
        storage_priority: () => {
          state.storage_priority = '';
        },
        upgrade_goal_primary: () => {
          state.primary_upgrade_goal = '';
          state.upgrade_goal_other = '';
        },
        upgrade_goal_other: () => {
          state.upgrade_goal_other = '';
        },
        current_pc_details: () => {
          state.current_pc_details = '';
        },
        current_pc_link: () => {
          state.current_pc_link = '';
        },
        prebuilt_options: () => {
          state.prebuilt_options = '';
        },
        additional_notes: () => {
          state.additional_notes = '';
        },
        review: () => {},
      };

      resetsByStep[step]?.();
    }

    async function handleNext() {
      try {
        hideError();
        syncStateFromForm();
        const currentStep = state.currentStep;
        const validation = validateStep(currentStep);

        if (!validation.valid) {
          showError(validation.message);
          return;
        }

        const steps = getActiveSteps();
        const currentIndex = getCurrentStepIndex();
        trackPcPlanEvent('pc_plan_question_answered', {
          question_number: currentIndex + 1,
          question_id: currentStep,
        });
        state.currentStep = steps[Math.min(currentIndex + 1, steps.length - 1)];
        saveState();
        render();
        focusCurrentStep();
      } catch (stepError) {
        showError(stepError?.message || 'Unable to move to the next step right now. Please try again.');
      }
    }

    function queueAutoAdvance() {
      window.clearTimeout(autoAdvanceTimer);
      autoAdvanceTimer = window.setTimeout(() => {
        autoAdvanceTimer = null;
        void handleNext();
      }, 75);
    }

    function shouldAutoAdvanceOnSelection(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return false;
      if (target.type !== 'radio' || !target.checked) return false;

      const stepPanel = target.closest('[data-vyrx-pc-plan-step]');
      if (!stepPanel) return false;

      const step = stepPanel.getAttribute('data-vyrx-pc-plan-step');
      return step === state.currentStep && isSelectionOnlyStep(step);
    }

    function isSelectionOnlyStep(step) {
      if (!step || step === 'review') return false;

      const panel = form.querySelector(`[data-vyrx-pc-plan-step="${CSS.escape(step)}"]`);
      if (!panel) return false;

      const hasRadioOptions = panel.querySelectorAll('input[type="radio"]').length > 0;
      const hasManualFields =
        panel.querySelector('textarea') ||
        panel.querySelector('input[type="text"]') ||
        panel.querySelector('input[type="url"]') ||
        panel.querySelector('input[type="email"]') ||
        panel.querySelector('input[type="number"]') ||
        panel.querySelector('input[type="tel"]');

      return hasRadioOptions && !hasManualFields;
    }

    function normalizeState() {
      if (state.budget_range !== 'other') {
        state.budget_other_amount = '';
      }

      if (state.primary_upgrade_goal !== 'other') {
        state.upgrade_goal_other = '';
      }

      if (!['gaming', 'gaming_streaming', 'mixed_use'].includes(state.primary_use)) {
        state.gaming_style = '';
        state.performance_target = '';
        state.target_resolution = '';
      }

      if (['gaming', 'gaming_streaming', 'mixed_use'].includes(state.primary_use)) {
        state.workload_focus = '';
      }

      if (state.plan_type !== 'upgrade_pc') {
        state.current_pc_details = '';
        state.primary_upgrade_goal = '';
        state.upgrade_goal_other = '';
        state.current_pc_link = '';
      }

      if (state.plan_type !== 'prebuilt') {
        state.prebuilt_options = '';
      }
    }

    function validateStep(step) {
      if (step === 'service' && !state.plan_type) return { valid: false, message: 'Choose what you need help with to move on.' };
      if (step === 'budget') {
        if (!state.budget_range) return { valid: false, message: 'Choose a budget range to move on.' };
      }
      if (step === 'budget_other' && !state.budget_other_amount.trim()) {
        return { valid: false, message: 'Enter your budget amount to move on.' };
      }
      if (step === 'use_primary' && !state.primary_use) {
        return { valid: false, message: 'Choose the main use to move on.' };
      }
      if (step === 'gaming_style' && !state.gaming_style) {
        return { valid: false, message: 'Choose the gaming style that fits best to move on.' };
      }
      if (step === 'workload_focus' && !state.workload_focus) {
        return { valid: false, message: 'Choose the workload that matters most to move on.' };
      }
      if (step === 'performance_target' && !state.performance_target) {
        return { valid: false, message: 'Choose what matters most to move on.' };
      }
      if (step === 'target_resolution' && !state.target_resolution) {
        return { valid: false, message: 'Choose the target resolution to move on.' };
      }
      if (step === 'aesthetics_style' && !state.aesthetics_style) {
        return { valid: false, message: 'Choose a preferred build style to move on.' };
      }
      if (step === 'appearance_importance' && !state.appearance_importance) {
        return { valid: false, message: 'Choose how much appearance matters to move on.' };
      }
      if (step === 'wifi_need' && !state.wifi_need) {
        return { valid: false, message: 'Choose whether Wi-Fi matters to move on.' };
      }
      if (step === 'storage_priority' && !state.storage_priority) {
        return { valid: false, message: 'Choose the storage priority to move on.' };
      }
      if (step === 'upgrade_goal_primary' && !state.primary_upgrade_goal) {
        return { valid: false, message: 'Choose the main upgrade goal to move on.' };
      }
      if (step === 'upgrade_goal_other' && !state.upgrade_goal_other.trim()) {
        return { valid: false, message: 'Add the upgrade goal details to move on.' };
      }
      if (step === 'current_pc_details') {
        if (!state.current_pc_details.trim()) {
          return { valid: false, message: 'Add whatever you know about your current PC to move on.' };
        }
      }
      return { valid: true };
    }

    function validateEntireIntake() {
      for (const step of getActiveSteps()) {
        const validation = validateStep(step);
        if (!validation.valid) {
          return { ...validation, step };
        }
      }

      return { valid: true, step: 'review' };
    }

    function syncStateFromForm() {
      const formData = new FormData(form);
      state.plan_type = formData.get('plan_type') || '';
      state.budget_range = formData.get('budget_range') || '';
      state.budget_other_amount = formData.get('budget_other_amount') || '';
      state.primary_use = formData.get('primary_use') || '';
      state.gaming_style = formData.get('gaming_style') || '';
      state.workload_focus = formData.get('workload_focus') || '';
      state.performance_target = formData.get('performance_target') || '';
      state.target_resolution = formData.get('target_resolution') || '';
      state.aesthetics_style = formData.get('aesthetics_style') || '';
      state.appearance_importance = formData.get('appearance_importance') || '';
      state.wifi_need = formData.get('wifi_need') || '';
      state.storage_priority = formData.get('storage_priority') || '';
      state.current_pc_details = formData.get('current_pc_details') || '';
      state.primary_upgrade_goal = formData.get('primary_upgrade_goal') || '';
      state.upgrade_goal_other = formData.get('upgrade_goal_other') || '';
      state.current_pc_link = formData.get('current_pc_link') || '';
      state.prebuilt_options = formData.get('prebuilt_options') || '';
      state.additional_notes = formData.get('additional_notes') || '';
      state.plan_acknowledgement = formData.get('plan_acknowledgement') === 'yes';
      normalizeState();
    }

    function applyStateToForm() {
      form.reset();
      for (const [key, value] of Object.entries(state)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            const input = form.querySelector(`[name="${key}"][value="${CSS.escape(item)}"]`);
            if (input) input.checked = true;
          });
          continue;
        }

        const input = form.elements.namedItem(key);
        if (!input) continue;

        if (input instanceof RadioNodeList) {
          Array.from(input).forEach((node) => {
            node.checked = node.value === value;
          });
        } else if (input.type === 'checkbox') {
          input.checked = Boolean(value);
        } else {
          input.value = value || '';
        }
      }
    }

    function render() {
      const activeSteps = getActiveSteps();
      if (!activeSteps.includes(state.currentStep)) state.currentStep = activeSteps[0];

      const currentIndex = getCurrentStepIndex();

      panels.forEach((panel) => {
        const step = panel.getAttribute('data-vyrx-pc-plan-step');
        const isActive = activeSteps.includes(step) && step === state.currentStep;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      syncChoiceLayouts();
      syncSelectionStates();
      syncReveals();
      renderSummary();

      const isCompletedState = state.currentStep === 'review';
      const isFirstStep = currentIndex === 0;
      const currentActionButton = getCurrentActionButton();

      shell.classList.toggle('is-complete', isCompletedState);
      document.body.classList.toggle('vyrx-pc-plan-intake-template--complete', isCompletedState);
      if (topbar) {
        topbar.setAttribute('aria-hidden', isCompletedState ? 'true' : 'false');
      }

      backButton.innerHTML = '<span aria-hidden="true">←</span><span>Back</span>';
      backButton.hidden = isFirstStep;

      panels.forEach((panel) => {
        const stepButton = panel.querySelector('[data-vyrx-pc-plan-next]');
        if (!stepButton) return;
        const isActivePanel = panel.classList.contains('is-active');
        const showButton = isActivePanel && !isSelectionOnlyStep(state.currentStep);
        stepButton.hidden = !showButton;
      });

      if (currentActionButton) {
        currentActionButton.textContent = getStepActionLabel(state.currentStep);
        currentActionButton.disabled = false;
      }

      stepCurrent.textContent = `${currentIndex + 1}`;
      stepTotal.textContent = `${activeSteps.length}`;
      progress.style.width = `${((currentIndex + 1) / activeSteps.length) * 100}%`;

      if (isCompletedState) {
        resetPreCheckoutReveal();
        startSequence();
      } else {
        resetPreCheckoutReveal();
        resetSequence();
        resetReceiptEmbed();
      }
    }

    function getCurrentActionButton() {
      const activePanel = form.querySelector(`[data-vyrx-pc-plan-step="${CSS.escape(state.currentStep)}"]`);
      return activePanel?.querySelector('[data-vyrx-pc-plan-next]') || null;
    }

    function syncSelectionStates() {
      form.querySelectorAll('.vyrx-pc-plan-page__choice, .vyrx-pc-plan-page__chip').forEach((item) => {
        const input = item.querySelector('input');
        item.classList.toggle('is-selected', Boolean(input?.checked));
      });
    }

    function syncChoiceLayouts() {
      form
        .querySelectorAll('.vyrx-pc-plan-page__choices, .vyrx-pc-plan-page__segmented')
        .forEach((group) => {
          const optionCount = Array.from(group.children).filter((child) => {
            return child.classList?.contains('vyrx-pc-plan-page__choice')
              || child.classList?.contains('vyrx-pc-plan-page__chip');
          }).length;

          group.classList.toggle('is-two-column', optionCount > 5);
        });
    }

    function syncReveals() {
      form.querySelectorAll('[data-vyrx-reveal]').forEach((node) => {
        const [name, expected] = node.getAttribute('data-vyrx-reveal').split(':');
        const currentValue = state[name];
        const shouldShow = Array.isArray(currentValue) ? currentValue.includes(expected) : currentValue === expected;
        node.hidden = !shouldShow;
      });
    }

    function renderSummary() {
      if (!summary) return;
      const summarySections = [];
      summarySections.push(buildSummaryRow('Service type', optionLabels.plan_type[state.plan_type] || 'Not provided', 'service'));
      summarySections.push(buildSummaryRow('Budget', formatBudget(), 'budget'));
      summarySections.push(buildSummaryRow('Main use', formatSingleChoice(state.primary_use, optionLabels.primary_use), 'use_primary'));

      if (['gaming', 'gaming_streaming', 'mixed_use'].includes(state.primary_use)) {
        summarySections.push(
          buildSummaryRow(
            'Gaming focus',
            [
              formatSingleChoice(state.gaming_style, optionLabels.gaming_style),
              formatSingleChoice(state.performance_target, optionLabels.performance_target),
              formatSingleChoice(state.target_resolution, optionLabels.target_resolution),
            ]
              .filter(Boolean)
              .join('<br>'),
            'gaming_style'
          )
        );
      } else {
        summarySections.push(buildSummaryRow('Workload focus', formatSingleChoice(state.workload_focus, optionLabels.workload_focus), 'workload_focus'));
      }

      summarySections.push(
        buildSummaryRow(
          'Build preferences',
          [
            formatSingleChoice(state.aesthetics_style, optionLabels.aesthetics_style),
            formatSingleChoice(state.appearance_importance, optionLabels.appearance_importance),
            formatSingleChoice(state.wifi_need, optionLabels.wifi_need),
            formatSingleChoice(state.storage_priority, optionLabels.storage_priority),
          ]
            .filter(Boolean)
            .join('<br>'),
          'aesthetics_style'
        )
      );

      if (state.plan_type === 'upgrade_pc') {
        summarySections.push(
          buildSummaryRow(
            'Current PC',
            [
              state.current_pc_details.trim(),
              formatSingleChoice(state.primary_upgrade_goal, optionLabels.upgrade_goals, state.upgrade_goal_other),
              state.current_pc_link.trim(),
            ]
              .filter(Boolean)
              .join('<br>'),
            'current_pc_details'
          )
        );
      }

      if (state.plan_type === 'prebuilt') {
        summarySections.push(buildSummaryRow('Prebuilt options', state.prebuilt_options.trim() || 'None added', 'prebuilt_options'));
      }

      summarySections.push(buildSummaryRow('Additional notes', state.additional_notes.trim() || 'None added', 'additional_notes'));
      summary.innerHTML = summarySections.join('');
    }

    function buildSummaryRow(label, value, step) {
      return `
        <div class="vyrx-pc-plan-page__summary-row">
          <div>
            <p class="vyrx-pc-plan-page__summary-label">${escapeHtml(label)}</p>
            <div class="vyrx-pc-plan-page__summary-value">${value || 'Not provided'}</div>
          </div>
          <button class="vyrx-pc-plan-page__summary-edit" type="button" data-vyrx-edit-step="${escapeHtml(step)}">Edit</button>
        </div>
      `;
    }

    function formatBudget() {
      if (!state.budget_range) return 'Not provided';
      if (state.budget_range === 'other') {
        return state.budget_other_amount.trim()
          ? `${escapeHtml(state.budget_other_amount.trim())} ${escapeHtml(budgetCurrencyCode)}`
          : 'Other amount';
      }
      return optionLabels.budget_range[state.budget_range] || state.budget_range;
    }

    function formatMultiValue(values, labels, otherText = '') {
      if (!values?.length) return '';
      return values
        .map((value) => {
          if (value === 'other' && otherText?.trim()) return `Other: ${escapeHtml(otherText.trim())}`;
          return escapeHtml(labels[value] || value);
        })
        .join(', ');
    }

    function formatSingleChoice(value, labels, otherText = '') {
      if (!value) return '';
      if (value === 'other' && otherText.trim()) return `Other: ${escapeHtml(otherText.trim())}`;
      return escapeHtml(labels[value] || value);
    }

    function getStepActionLabel(step) {
      const labels = {
        budget_other: 'Use this budget',
        upgrade_goal_other: 'Use this goal',
        current_pc_details: 'Use these specs',
        current_pc_link: state.current_pc_link.trim() ? 'Use this link' : 'Skip link',
        prebuilt_options: state.prebuilt_options.trim() ? 'Use these options' : 'Skip for now',
        additional_notes: 'Complete my intake',
        review: '',
      };

      return labels[step] || '';
    }

    function buildProperties() {
      const properties = {
        'Selected Service': 'PC Plan',
        'VYRX PC Plan Intake ID': state.submission_id,
        'VYRX PC Plan Status': state.submission_status || 'pending_payment',
        'PC Plan Type': optionLabels.plan_type[state.plan_type] || '',
        'Budget Currency': budgetCurrencyCode,
        Budget: formatBudget().replace(/<[^>]*>/g, ''),
        'Primary Use': stripHtml(formatSingleChoice(state.primary_use, optionLabels.primary_use)),
        'Gaming Style': stripHtml(formatSingleChoice(state.gaming_style, optionLabels.gaming_style)),
        'Workload Focus': stripHtml(formatSingleChoice(state.workload_focus, optionLabels.workload_focus)),
        'Performance Target': stripHtml(formatSingleChoice(state.performance_target, optionLabels.performance_target)),
        'Target Resolution': stripHtml(formatSingleChoice(state.target_resolution, optionLabels.target_resolution)),
        'Aesthetics Style': stripHtml(formatSingleChoice(state.aesthetics_style, optionLabels.aesthetics_style)),
        'Appearance Importance': stripHtml(formatSingleChoice(state.appearance_importance, optionLabels.appearance_importance)),
        'Wi-Fi Need': stripHtml(formatSingleChoice(state.wifi_need, optionLabels.wifi_need)),
        'Storage Priority': stripHtml(formatSingleChoice(state.storage_priority, optionLabels.storage_priority)),
        'Additional Notes': state.additional_notes.trim(),
      };

      if (state.plan_type === 'upgrade_pc') {
        properties['Current PC Details'] = state.current_pc_details.trim();
        properties['Upgrade Goal'] = stripHtml(formatSingleChoice(state.primary_upgrade_goal, optionLabels.upgrade_goals, state.upgrade_goal_other));
        properties['Current PC Link'] = state.current_pc_link.trim();
      }

      if (state.plan_type === 'prebuilt') {
        properties['Prebuilt Options'] = state.prebuilt_options.trim();
      }

      return Object.entries(properties).filter(([, value]) => value);
    }

    function ensureSubmissionMetadata() {
      if (!state.submission_id) {
        state.submission_id = generateSubmissionId();
      }

      state.submission_status = 'pending_payment';
      state.submitted_at = new Date().toISOString();
      saveState();
    }

    function generateSubmissionId() {
      if (window.crypto?.randomUUID) {
        return `vyrx-pc-plan-${window.crypto.randomUUID()}`;
      }

      return `vyrx-pc-plan-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }

    function buildCartAttributes() {
      return {
        'VYRX PC Plan Intake ID': state.submission_id,
        'VYRX PC Plan Status': state.submission_status,
        'VYRX PC Plan Saved At': state.submitted_at,
        'VYRX PC Plan Product Title': section.dataset.productTitle || 'VYRX PC Plan',
        'VYRX PC Plan Variant ID': section.dataset.variantId || '',
        'VYRX PC Plan Type': optionLabels.plan_type[state.plan_type] || '',
        'VYRX PC Plan Type Key': state.plan_type,
        'VYRX PC Plan Budget Currency': budgetCurrencyCode,
        'VYRX PC Plan Budget': formatBudget().replace(/<[^>]*>/g, ''),
      };
    }

    async function persistSubmission() {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: buildCartAttributes(),
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to save your PC Plan intake right now. Please try again.');
      }
    }

    async function submitToCheckout(triggerButton = null) {
      const currentActionButton = getCurrentActionButton();
      const actionButton = triggerButton || currentActionButton;
      if (actionButton) {
        actionButton.disabled = true;
        actionButton.dataset.loading = 'true';
        actionButton.setAttribute('aria-busy', 'true');
      }
      propertiesTarget.innerHTML = '';

      try {
        const fullValidation = validateEntireIntake();
        if (!fullValidation.valid) {
          state.currentStep = fullValidation.step;
          saveState();
          render();
          focusCurrentStep();
          throw new Error(fullValidation.message);
        }

        ensureSubmissionMetadata();
        await persistSubmission();

        const variantId = cartForm.querySelector('[name="id"]')?.value || section.dataset.variantId || '';
        if (!variantId) {
          throw new Error('PC Plan product is not configured correctly. Select the VYRX PC Plan product in Theme settings.');
        }

        const properties = Object.fromEntries(buildProperties());

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties,
              },
            ],
          }),
        });

        if (!response.ok) {
          let detail = 'Unable to start checkout right now. Please try again.';
          try {
            const errorPayload = await response.json();
            detail = errorPayload?.description || errorPayload?.message || detail;
          } catch {}
          throw new Error(detail);
        }

        navigateToCheckout(getCheckoutDestination());
      } catch (submitError) {
        showError(submitError?.message || 'Something went wrong adding your PC Plan to the cart. Your answers are saved — please try again.');
      } finally {
        if (actionButton) {
          actionButton.disabled = false;
          delete actionButton.dataset.loading;
          actionButton.removeAttribute('aria-busy');
        }
      }
    }

    function showError(message) {
      error.hidden = false;
      error.textContent = message;
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function hideError() {
      error.hidden = true;
      error.textContent = '';
    }

    function focusCurrentStep() {
      const activePanel = form.querySelector(`[data-vyrx-pc-plan-step="${CSS.escape(state.currentStep)}"]`);
      if (!activePanel) return;
      window.requestAnimationFrame(() => {
        activePanel.focus({ preventScroll: true });
      });
    }

    function stripHtml(value) {
      return value.replace(/<[^>]*>/g, '');
    }

    function escapeHtml(value) {
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }
  });
});
